import { isNotNullish } from '@nx/stdlib';
import { keyBy } from 'lodash-es';

import type {
  BaseMetricsRequest,
  MetricMetadata,
  MetricsMetadataResponse,
  MetricsRequestType,
  MetricsResponse,
} from '../api-types/metrics';
import { transformMetrics } from '../transformers/metrics';
import type { Builder } from './types';

const getMetricsRequestUrl = (type: MetricsRequestType) => {
  switch (type) {
    case 'metrics':
      return '/metrics';
    case 'metricsWithAggregations':
      return '/metrics/aggregations';
    case 'metricsWithAZGrouping':
      return '/metrics/az-grouping';
    case 'fleetMetrics':
      return '/metrics/fleet';
    default:
      throw new Error('Invalid metrics request type');
  }
};

export const metricsEndpoints = (builder: Builder) => ({
  getMetrics: builder.query<MetricsResponse, { metricsRequest: BaseMetricsRequest; type: MetricsRequestType }>({
    query: (args) => ({
      url: getMetricsRequestUrl(args.type),
      method: 'POST',
      body: args.metricsRequest,
      headers: { 'Project-Id': args.metricsRequest.tenantId },
    }),
    transformResponse: (metrics: MetricsResponse) => {
      return transformMetrics(metrics);
    },
    providesTags: (result, error, args) => {
      let cacheId = args.metricsRequest.dbmsId;
      if (isNotNullish(args.metricsRequest.deploymentId)) {
        cacheId = args.metricsRequest.deploymentId;
      }
      return [{ type: 'Metrics', id: cacheId }];
    },
  }),
  getMetricsMetadata: builder.query<Record<string, MetricMetadata>, string>({
    query: (tenantId) => ({ url: '/metrics/metadata', headers: { 'Project-Id': tenantId } }),
    transformResponse: (metricsMetadataRes: MetricsMetadataResponse): Record<string, MetricMetadata> => {
      return keyBy(metricsMetadataRes, (metadata) => metadata.name);
    },
  }),
});
